import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Button,
} from "@heroui/react";
import { useModal } from 'react-modal-hook';

export default function useConfirm({
  isSubmitting,
  onSubmit,
  title,
}: {
  isSubmitting?: boolean;
  onSubmit: () => Promise<void>;
  title?: string;
}) {
  const [showModal, hideModal] = useModal(
    () => (
      <Modal
        defaultOpen
        // classNames={{ wrapper: "z-100" }}
        close
        hideCloseButton
        onClose={hideModal}
      >
        <ModalContent className='pt-4 pb-safe rounded-3xl'>
          {(onClose) => (
            <>
              <ModalHeader className='text-center flex justify-center text-xl'>
                {title || '确认是否删除?'}
              </ModalHeader>

              <ModalFooter className='grid grid-cols-2 gap-4'>
                <Button
                  // variant="light"
                  onPress={onClose}
                  className='font-bold bg-gray-100'
                  radius='full'
                  size='lg'
                >
                  取消
                </Button>
                <Button
                  isLoading={isSubmitting}
                  color='danger'
                  className='font-bold'
                  radius='full'
                  size='lg'
                  onPress={() => {
                    onSubmit().then(onClose);
                  }}
                >
                  确定
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    ),
    [isSubmitting]
  );

  return { showModal };
}
